import React from 'react'
import { Form } from 'lib/ui'
import { Container, Grid } from './styled'
import { Field } from 'formik'
import { onlyNumbersInterceptor } from 'lib/shared'
import { useIntl } from 'react-intl'

export const CommerceHubCreditCardForm = () => {
  const intl = useIntl()
  return (
    <Container>
      <Form.Wrapper>
        <Field
          name='cardholderName'
          label={intl.formatMessage({
            id: 'checkout.billing.ccForm.label.name'
          })}
          component={Form.Input}
          placeholder='Cardholder Name'
          isRequired
        />
        <Field
          name='ccNumber'
          label={intl.formatMessage({
            id: 'checkout.billing.ccForm.label.number'
          })}
          component={Form.Input}
          maxLength='16'
          placeholder='XXXX-XXXX-XXXX-XXXX'
          interceptChange={onlyNumbersInterceptor}
          isRequired
        />

        <Grid>
          <div>
            <Field
              name='ccExpMonth'
              placeholder='Month'
              label={intl.formatMessage({
                id: 'checkout.billing.ccForm.label.expMonth'
              })}
              component={Form.Select}
              options={monthOptions}
              isRequired
            />
          </div>
          <div className='field'>
            <Field
              name='ccExpYear'
              placeholder='Year'
              label={intl.formatMessage({
                id: 'checkout.billing.ccForm.label.expYear'
              })}
              component={Form.Select}
              options={yearOptions}
              isRequired
            />
          </div>
          <div>
            <Field
              name='ccCid'
              label={intl.formatMessage({
                id: 'checkout.billing.ccForm.label.cvv'
              })}
              component={Form.Input}
              maxLength='4'
              interceptChange={onlyNumbersInterceptor}
              isRequired
            />
          </div>
        </Grid>
      </Form.Wrapper>
    </Container>
  )
}

interface Option {
  label: string
  value: string
}

const yearOptions = getYearsOptions()
const monthOptions = getMonthOptions()

function getYearsOptions (): Option[] {
  const options = []
  const lastYear = (new Date().getFullYear())
  for (let i = lastYear; i <= (lastYear + 19); i++) {
    const year = i.toString()
    options.push({
      value: year,
      label: year
    })
  }
  options.unshift({
    value: '',
    label: ''
  })
  return options
}

function getMonthOptions (): Option[] {
  const options = []
  for (let i = 1; i <= 12; i++) {
    const month = `00${i}`.slice(-2)
    options.push({
      value: month,
      label: i.toString()
    })
  }
  options.unshift({
    value: '',
    label: ''
  })
  return options
}
